module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.password,
      "rules": [function () { return _vm.newPassword.length > 0 || ("" + (_vm.$lang.errors.missingPass)); }],
      "append-icon": _vm.show ? 'visibility' : 'visibility_off',
      "type": _vm.show ? 'text' : 'password'
    },
    on: {
      "click:append": function($event) {
        _vm.show = !_vm.show
      }
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": "",
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "disabled": _vm.updating
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0 primary",
    attrs: {
      "disabled": !_vm.isValid || _vm.updating,
      "loading": _vm.updating
    },
    on: {
      "click": function($event) {
        return _vm.updatePassApi()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.submit) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6471d075","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ChangePassword.vue
// module id = 584
// module chunks = 8